exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  position: relative; }\n  :host .icon {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 50px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    font-size: 22px;\n    padding: 10px 0; }\n  :host .message {\n    margin-left: 50px;\n    padding: 10px 5px 10px 0; }\n    :host .message /deep/ p {\n      padding: 0;\n      margin: 0; }\n  :host.warning {\n    background: #FFECDD; }\n    :host.warning .icon, :host.warning .message {\n      color: #ff9744; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.scss
// module id = 469
// module chunks = 1